<template>
<div>
    <div class="vxMintBg" v-if="!isMobile()">
        <br><br><br><br>
        <div  data-v-a589c2a8="" id="clabs-section" class="clabsSection zoom-in" > 
            <div  class="clabsSection__pass soldierPass clabsSection__left">
                <a  name="CosmicLabs" class="clabsLink" id="CosmicLabs"></a> <img class="tier2Size"  src="../../assets/VX/tier2.gif" >
                <h3  class="is-text-bold TitleSection">Soldier</h3>
                <ul >
                <li class="biggerFont">1500 Genesis VX Soldier Models</li>
                <li class="biggerFont">Playable in Sandbox</li>
                <li class="biggerFont">Token Range 1501-3000</li>
                </ul>
                <h4 class="totalSupply">{{1500 - totalSoldiers}} / 1500 Remaining</h4>
                <br>
                <h5 class="inputTxt">Amount to mint</h5>
                <input class="inputAmount" type="number" min="1" :max="maxMint"  v-model="totalAmount"> 
                <br>
                <button @click="mintVx(1)" class="soldierMint">FREE MINT</button>
            </div>
            <div  class="clabsSection__pass commanderPass">
                <img class="tier2Size"  src="../../assets/VX/tier2.gif">
                <h3  class="is-text-bold TitleSection">Soldier</h3>
                <ul  class="second-list">
                <li class="biggerFont">1500 Genesis VX Soldier Models</li>
                <li class="biggerFont">Playable in Sandbox</li>
                <li class="biggerFont">Token Range 501-1500</li>
                </ul>
                <br>
                <h4 class="totalSupply">{{1000 - totalCommanders}} / 1000 Remaining</h4>
                <br>
                <h5 class="inputTxt">Amount to mint</h5>
                <input class="inputAmount" type="number" min="1" :max="maxMint"  v-model="totalAmount">
                <br>
                <button @click="mintVx(2)" class="soldierMint">FREE MINT</button>
            </div>
            <div  class="clabsSection__pass generalPass">
                <img class="tier2Size"  src="../../assets/VX/tier2.gif" >
                <h3  class="is-text-bold TitleSection">Soldier</h3>
                <ul  class="second-list">
                <li class="biggerFont">1500 Genesis VX Soldier Models</li>
                <li class="biggerFont">Playable in Sandbox</li>
                <li class="biggerFont">Token Range 1-500</li>
                </ul>
                <br>
                <h4 class="totalSupply">{{500 - totalGenerals}} / 500 Remaining</h4>
                <br>
                <h5 class="inputTxt">Amount to mint</h5>
                <input class="inputAmount" type="number" min="1" :max="maxMint"  v-model="totalAmount">
                <br>
                <button @click="mintVx(3)" class="soldierMint">FREE MINT</button>
            </div>
        </div>

        <b-container>
            <b-row>
                <b-col cols="12">
                    <br><br><br><br>
                </b-col>
            </b-row>
        </b-container>


    </div>

    <div>
        <b-container v-if="isMobile()" class="containerBG">
        <div  data-v-a589c2a8="" id="clabs-section" class="clabsSectionMobile zoom-in"> 
            <b-row class="soliderPassMobile">
                <b-col cols="12">
                        <div  class="clabsSectionMobile__pass soldierPassMobile clabsSectionMobile__left">
                            <a  name="CosmicLabs" class="clabsLink" id="CosmicLabs"></a> <img class="tier2Size"  src="../../assets/VX/tier2.gif" >
                            <h3  class="is-text-bold TitleSection">Soldier</h3>
                            <ul >
                            <li >3000 Genesis VX Soldier Models</li>
                            <li>Playable in Sandbox</li>
                            <li>Token Range 1501-3000</li>
                            </ul>
                            <h4 class="totalSupply">{{1500 - totalSoldiers}} / 1500 Remaining</h4>
                            <br>
                            <h5 class="inputTxt">Amount to mint</h5>
                            <input class="inputAmount" type="number" min="1" :max="maxMint"  v-model="totalAmount">
                            <br>
                            <button @click="mintVx(1)" class="soldierMint">FREE MINT</button>
                        </div>
                        </b-col>
            </b-row>

            <b-row class="commanderPassMobile">
                <b-col cols="12">
                    <div  class="clabsSectionMobile__pass ">
                            <img class="tier2Size"  src="../../assets/VX/tier2.gif">
                            <h3  class="is-text-bold TitleSection">Soldier</h3>
                            <ul  class="second-list">
                            <li >3000 Genesis VX Soldier Models</li>
                            <li>Playable in Sandbox</li>
                            <li>Token Range 501-1500</li>
                            </ul>
                            <h4 class="totalSupply">FREE MINT</h4>
                            <br>
                            <h5 class="inputTxt">Amount to mint</h5>
                            <input class="inputAmount" type="number" min="1" :max="maxMint"  v-model="totalAmount">
                            <br>
                            <button @click="mintVx(2)" class="soldierMint">FREE ETH MINT</button>
                        </div>

                </b-col>
            </b-row>
            <b-row class="generalPassMobile">
                <b-col cols="12">
                    <div  class="clabsSectionMobile__pass ">
                            <img class="tier2Size"  src="../../assets/VX/tier2.gif" >
                            <h3  class="is-text-bold TitleSection">Soldier</h3>
                            <ul  class="second-list">
                            <li >3000 Genesis VX Soldier Models</li>
                            <li>Playable in Sandbox</li>
                            <li>Token Range 1-500</li>
                            </ul>
                            <h4 class="totalSupply">{{500 - totalGenerals}} / 500 Remaining</h4>
                            <br>
                            <h5 class="inputTxt">Amount to mint</h5>
                            <input class="inputAmount" type="number" min="1" :max="maxMint"  v-model="totalAmount">
                            <br>
                            <button @click="mintVx(3)" class="soldierMint">FREE MINT</button>
                        </div>
                </b-col>
            </b-row>
                    
                
        </div>
    </b-container>

    </div>
</div>
</template>

<script>
import Web3 from 'web3';
import vxContract from './vxContract.json'
import MerkleTree from 'merkletreejs';
import Keccak256 from 'keccak256';
import whitelist from './vxWhitelist.json'

export default {
    data: function () {
            return {
                web3: '',

                walletAddress: '',
                walletBalance: '',
                vxContract: '',
                contractAddress: vxContract.contractAddress,
                contractABI: vxContract.abi,

                merkleTree: MerkleTree,
                keccak256: Keccak256,
                vxWhitelist: whitelist,


                loadingTransaction: false,
                wlOpen: false,
                totalAmount: 1,
                maxMint: 3,

                totalSoldiers: 0,
                totalCommanders: 0,
                totalGenerals: 0,

                
            }
    },
    mounted()
    {
        this.LoadEthWallet();
        const leafNodes = this.vxWhitelist.map(addr => keccak256(addr));
        const tree = new this.merkleTree(leafNodes, this.keccak256, { sortPairs: true});

        console.log(tree.toString().substring(0,100))
    },
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        mintVx(tierList)
        {
            if(this.wlOpen)
            {
                const leafNodes = this.vxWhitelist.map(addr => keccak256(addr));
                const tree = new this.merkleTree(leafNodes, this.keccak256, { sortPairs: true});
                const root = tree.getRoot();
                var indexForMsgSender = this.vxWhitelist.indexOf(this.walletAddress);
                
                if(indexForMsgSender >= 0)
                {
                }
                else
                {
                    indexForMsgSender = this.vxWhitelist.indexOf(this.walletAddress.toLowerCase());
                }

                if(indexForMsgSender >= 0)
                {
                    this.loadingTransaction = true;
                    const claimingAccount = leafNodes[indexForMsgSender];
                    const hexProof = tree.getHexProof(claimingAccount);

                    this.vxContract.methods.whitelistMint(hexProof, tierList, this.totalAmount).send({from: this.walletAddress})
                    .on('confirmation', function(confirmationNumber, receipt)
                    {
                        
                    })
                    .then(res=>{
                        this.LoadContract();
                        this.loadingTransaction = false;
                    })
                    .catch(err=>{
                        this.LoadContract();
                        this.loadingTransaction = false;
                    })
                }
                else
                {
                    alert("You are not whitelisted!")
                }
            }
            else
            {
                

                this.vxContract.methods.publicMint(tierList, this.totalAmount).send({from: this.walletAddress})
                .on('confirmation', function(confirmationNumber, receipt)
                {
                    
                })
                .then(res=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
                .catch(err=>{
                    this.LoadContract();
                    this.loadingTransaction = false;
                })
            }
        },
        async chainChange()
        {
            await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                });
            this.LoadEthWallet();
        },
        LoadEthWallet: function(){
            if (typeof window.ethereum !== 'undefined') 
            {
            this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/5953fa0192404ecca6c68f5c0ca2dd70") || Web3.givenProvider);
            this.web3.eth.net.getNetworkType()
            .then(network=>{
                if(network == "main")
                {
                
                this.web3.eth.requestAccounts()
                    .then(acc=>{
                    this.walletAddress = acc[0];
                    this.web3.eth.getBalance(this.walletAddress)
                        .then(balance=>{
                            this.walletBalance = this.web3.utils.fromWei(balance, "ether");
                            this.LoadContract();     
                        });
                    })
                    .catch(err=>{
                        console.log(err);
                    })            
                }
                else{
                    this.chainChange();
                }          
            })
            }
        },
        LoadContract: function()
        {
            this.vxContract = new this.web3.eth.Contract(this.contractABI, this.contractAddress);

            this.vxContract.methods.howManySoldiersMinted().call({from: this.walletAddress})
            .then(res=>{
                this.totalSoldiers = res;
            })
            this.vxContract.methods.howManyCommandersMinted().call({from: this.walletAddress})
            .then(res=>{
                this.totalCommanders = res;
            })
            this.vxContract.methods.howManyGeneralsMinted().call({from: this.walletAddress})
            .then(res=>{
                this.totalGenerals = res;
            })

            this.vxContract.methods.isWLOpen().call({from: this.walletAddress})
            .then(res=>{
                this.wlOpen = res;

                if(res)
                {
                    this.vxContract.methods.maxPerWLWallet().call({from: this.walletAddress})
                    .then(res2=>{
                        this.maxMint = res2;
                    })
                }
                else
                {
                    this.vxContract.methods.maxPerPublicWallet().call({from: this.walletAddress})
                    .then(res3=>{
                        this.maxMint = res3;
                    })
                }
            })

        }
    }
}
</script>

<style scoped>
.vxMintBg
{
    background: url("../../assets/VX/neocity.png");
    background-repeat: no-repeat;
    background-size: cover;
}
ul li {
    /* Bullet color */
    color: white;
    text-align: left !important;
    list-style-position: inside;
    list-style-type: disc;
}

ul li span {
    /* Text color */
    color: white;
    font-size: 2vh;
    
}
.modelText
{
    margin-top: 2vh;
    color: white;
    font-size: 3vh;
}
.cardDetails
{
    background: #1d0a28;
    margin-top: 10vh;
    border: 4px solid white;
    border-radius: 100px / 100px;
    margin-bottom: 10vh;
}

.inputAmount
{
    text-align: center;
    border-radius: 999px;
    color: black;
    width: 60px;
}
.inputTxt
{
    color: #82f5eb;
}
.totalSupply
{
    font-size: 2vh;
}
.vxSized
{
  height: 250px;
  margin: 0 !important;
}
.increaseSize
{
  transform: scale(1.2);
  margin: 0 !important;
}
.bcards
{
  margin-top: 10vh;
  display: flex;
  background: transparent;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50px;
}
/* CSS */
.soldierMint {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border-radius: 24px;
  border-style: none;
  box-shadow: rgba(0, 0, 0, .2) 0 3px 5px -1px,rgba(0, 0, 0, .14) 0 6px 10px 0,rgba(0, 0, 0, .12) 0 1px 18px 0;
  box-sizing: border-box;
  color: #3c4043;
  cursor: pointer;
  display: inline-flex;
  position: absolute;
  fill: currentcolor;
  font-size: 14px;
  font-weight: 500;
  height: 48px;
  justify-content: center;
  letter-spacing: .25px;
  line-height: normal;
  max-width: 100%;
  overflow: visible;
  padding: 2px 24px;
  position: relative;
  text-align: center;
  text-transform: none;
  transition: box-shadow 280ms cubic-bezier(.4, 0, .2, 1),opacity 15ms linear 30ms,transform 270ms cubic-bezier(0, 0, .2, 1) 0ms;
  width: auto;
  will-change: transform,opacity;
  z-index: 0;
}


.soldierMint:hover {
  background: #F6F9FE;
  color: #62bbb3;
}

.soldierMint:active {
  box-shadow: 0 4px 4px 0 rgb(60 64 67 / 30%), 0 8px 12px 6px rgb(60 64 67 / 15%);
  outline: none;
}

.soldierMint:focus {
  outline: none;
  border: 2px solid #82f5eb;
}

.soldierMint:not(:disabled) {
  box-shadow: rgba(60, 64, 67, .3) 0 1px 3px 0, rgba(60, 64, 67, .15) 0 4px 8px 3px;
}

.soldierMint:not(:disabled):hover {
  box-shadow: rgba(60, 64, 67, .3) 0 2px 3px 0, rgba(60, 64, 67, .15) 0 6px 10px 4px;
}

.soldierMint:not(:disabled):focus {
  box-shadow: rgba(60, 64, 67, .3) 0 1px 3px 0, rgba(60, 64, 67, .15) 0 4px 8px 3px;
}

.soldierMint:not(:disabled):active {
  box-shadow: rgba(60, 64, 67, .3) 0 4px 4px 0, rgba(60, 64, 67, .15) 0 8px 12px 6px;
}

.soldierMint:disabled {
  box-shadow: rgba(60, 64, 67, .3) 0 1px 3px 0, rgba(60, 64, 67, .15) 0 4px 8px 3px;
}



.clabsSection {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    color: white;
    
}
.clabsSectionMobile {
    display: block;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    color: white;
    
}
.TitleSection
{
    color: #82f5eb;
}

.clabsSection__pass {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius:100px / 100px;
    padding: 60px;
    width: 540px;
    height: 925px;
    margin: 0 20px;
    margin-top: -5vh;
}
.soldierPass
{
    background: url("../../assets/VX/mintCards/bg1.png") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    border: 2px solid #82f5eb;
    transform: scale(0.8);
}
.soliderPassMobile
{
    background: url("../../assets/VX/mintCards/bg1.png") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    height: 1000px;
}
.commanderPass
{
    background: url("../../assets/VX/mintCards/bg2.png") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    border: 2px solid #82f5eb;
    transform: scale(0.8);
}
.commanderPassMobile
{
    background: url("../../assets/VX/mintCards/bg2.png") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    height: 1000px;
}
.generalPass
{
    background: url("../../assets/VX/mintCards/bg3.png") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    border: 2px solid #82f5eb;
    transform: scale(0.8);
}
.generalPassMobile
{
    background: url("../../assets/VX/mintCards/bg3.png") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    height: 1000px;
}


.clabsSectionMobile__pass {
    position: relative;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 30px;
    padding: 60px;
    width: 100%;
    margin-top: 5vh;
    height: 850px;
    
}
.clabsLink {
    position: absolute;
    top: 0;
    right: unset;
    bottom: unset;
    left: 0;
    z-index: 1;
}
.clabsSection__pass img {
    
    height: 295px;
    -o-object-fit: contain;
    object-fit: contain;
}
.clabsSectionMobile__pass img {
    
    height: 295px;
    -o-object-fit: contain;
    object-fit: contain;
}
.tier2Size
{
    transform: scale(1.4);

}


.clabsSection__pass h3 {
    text-transform: uppercase;
    font-size: 30px;
    margin: 20px 0;
    text-align: left;
}
.clabsSection__pass p {
    font-size: 15px;
    line-height: 18px;
}
.clabsSection__pass ul {
    padding-left: 25px;
    padding-right: 25px;
    flex: auto;
}
.clabsSection__pass ul li {
    margin: 15px 0;
    line-height: 25px;
    font-size: 20px;
    position: relative;
}




.clabsSectionMobile__pass h3 {
    text-transform: uppercase;
    font-size: 30px;
    margin: 20px 0;
    text-align: left;
}
.clabsSectionMobile__pass p {
    font-size: 15px;
    line-height: 18px;
}
.clabsSectionMobile__pass ul {
    padding-left: 25px;
    padding-right: 25px;
    flex: auto;
}
.clabsSectionMobile__pass ul li {
    margin: 15px 0;
    line-height: 20px;
    font-size: 15px;
    position: relative;
}




@media only screen and (max-width: 1360px) {
.clabsSection {
    display: flex;
  }
  .clabsSection__pass
  {
    width: 400px !important;
    height: 1000px;
  }
}

@media only screen and (max-width: 1009px) {
.clabsSection {
    display: block;
  }
  .clabsSection__pass
  {
    width: auto !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Vx/Mint.vue